<template>
  <div class="page-container">
    <div>
      <el-button v-if="!noContent" type="primary" @click="addOrUpdateHandle()">New Template</el-button>
    </div>
    <div class="el-list protocols-wrapper">
      <el-row v-loading="dataListLoading" :gutter="30">
        <el-col v-if="noContent">
          <el-empty description=" ">
            <el-button type="primary" @click="addOrUpdateHandle()">New Template</el-button>
          </el-empty>
        </el-col>
        <template v-if="!noContent">
          <el-col :span="6" v-for="item in dataList" :key="item.id">
            <el-card shadow="nerver" :body-style="{ padding: '0px' }" class="mt16 relative">
              <div class="module-item">
                <div class="module-desc">
                  <!-- <div class="title">
                    <span>{{ templateFormat(item.type) }}</span>
                  </div>
                  <div class="date">
                    update at
                    <span>{{ item.updateTime }}</span>
                  </div> -->
                  <p class="item-wrap">
                    <span class="item-label">Type:</span>
                    <span class="item-content">{{ templateFormat(item.type) }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="item-label">Status:</span>
                    <span class="item-content" v-if="item.status == 0">Disable</span>
                    <span class="item-content" v-if="item.status == 1">Enable</span>
                  </p>
                  <p class="item-wrap">
                    <span class="item-label">Update:</span>
                    <span class="item-content">{{ item.updateTime }}</span>
                  </p>
                </div>
              </div>
              <ul v-if="item.id <= 10" class="el-card-actions">
                <li style="width: 100%" @click="addOrUpdateHandle(item.id)">
                  <svg-icon name="edit" class="fs16"></svg-icon>
                </li>
              </ul>
              <ul v-else class="el-card-actions">
                <li style="width: 50%" @click="deleteHandle(item.id)">
                  <svg-icon name="delete" class="fs16"></svg-icon>
                </li>
                <li style="width: 50%" @click="addOrUpdateHandle(item.id)">
                  <svg-icon name="edit" class="fs16"></svg-icon>
                </li>
              </ul>
            </el-card>
          </el-col>
        </template>
      </el-row>
    </div>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      :templateTypes="templateTypes"
      :triggerTypes="triggerTypes"
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    ></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./AddOrUpdate";
export default {
  components: {
    AddOrUpdate,
  },
  data() {
    return {
      dataForm: {},
      dataList: [],
      dataListLoading: false,
      addOrUpdateVisible: false,
      templateTypes: [
        {
          title: "Sign Up",
          value: "SIGN_UP",
        },
        {
          title: "Sign Up Success",
          value: "SIGN_UP_SUCCESS",
        },
        {
          title: "Reset Password",
          value: "RESET_PASSWORD",
        },
        {
          title: "Reset Password Success",
          value: "RESET_PASSWORD_SUCCESS",
        },
        {
          title: "Change Email",
          value: "CHANGE_EMAIL",
        },
        {
          title: "Company Application Partly Filled Out",
          value: "COMPANY_APPLYMENT_PARTLY_FILLED_OUT",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB3",
              tip: "expire time",
            },
            {
              title: "NB3.a",
              tip: "apply time",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
          ],
        },
        {
          title: "Company Application Invoice Notify",
          value: "COMPANY_APPLYMENT_INVOICE",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB3",
              tip: "expire time",
            },
            {
              title: "NB3.a",
              tip: "apply time",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
            {
              title: "NB5",
              tip: "invoice price",
            },
            {
              title: "NB5.5",
              tip: "invoice link",
            },
          ],
        },
        {
          title: "Company Application Payment Received",
          value: "COMPANY_APPLYMENT_ORDER_COMPLETE",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
            {
              title: "NB5",
              tip: "invoice price",
            },
          ],
        },
        {
          title: "Company Application Revision Notify",
          value: "COMPANY_APPLYMENT_REJECTED",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
          ],
        },
        {
          title: "Company Application Failed Notify",
          value: "COMPANY_APPLYMENT_ACRA_REJECTED",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
          ],
        },
        {
          title: "Company Application Completed",
          value: "COMPANY_INCORPORATED",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
            {
              title: "NB6",
              tip: "company name",
            },
            {
              title: "NB7",
              tip: "company incorporate time",
            },
          ],
        },
        {
          title: "Order Refunding",
          value: "ORDER_REFUNDING",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
            {
              title: "NB5",
              tip: "invoice price",
            },
            {
              title: "NB5.5",
              tip: "invoice link",
            },
          ],
        },
        {
          title: "Order Refunded",
          value: "ORDER_REFUNDED",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
            {
              title: "NB5",
              tip: "invoice price",
            },
            {
              title: "NB6",
              tip: "refunded amount",
            },
            {
              title: "NB6.5",
              tip: "credit invoice",
            },
          ],
        },
        {
          title: "Company Application Partially Paid",
          value: "COMPANY_APPLYMENT_ORDER_PARTLY_PAID",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB3",
              tip: "expire time",
            },
            {
              title: "NB3.a",
              tip: "apply time",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
            {
              title: "NB5",
              tip: "invoice price",
            },
            {
              title: "NB5.5",
              tip: "invoice link",
            },
          ],
        },
        {
          title: "Company Customization Invoice Notify",
          value: "COMPANY_APPLYMENT_PART_INVOICE",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB3",
              tip: "expire time",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
            {
              title: "NB5",
              tip: "invoice price",
            },
            {
              title: "NB5.5",
              tip: "invoice link",
            },
            {
              title: "NB8",
              tip: "billing party",
            },
            {
              title: "NB9",
              tip: "statement",
            },
          ],
        },
        {
          title: "Company Customization Partially Paid",
          value: "COMPANY_APPLYMENT_PART_ORDER_PARTLY_PAID",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB3",
              tip: "expire time",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
            {
              title: "NB5",
              tip: "invoice price",
            },
            {
              title: "NB5.5",
              tip: "invoice link",
            },
            {
              title: "NB8",
              tip: "billing party",
            },
            {
              title: "NB9",
              tip: "statement",
            },
          ],
        },
        {
          title: "Company Customization Payment Received",
          value: "COMPANY_APPLYMENT_PART_ORDER_COMPLETE",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB3",
              tip: "expire time",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
            {
              title: "NB5",
              tip: "invoice price",
            },
            {
              title: "NB5.5",
              tip: "invoice link",
            },
            {
              title: "NB8",
              tip: "billing party",
            },
            {
              title: "NB9",
              tip: "statement",
            },
          ],
        },
        {
          title: "Quotation Passed",
          value: "QUOTATION_PASSED",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
          ],
        },
        {
          title: "Company Customization Terminated",
          value: "APPLYMENT_TERMINATED",
          variables: [
            {
              title: "NB1",
              tip: "transaction no",
            },
            {
              title: "NB2",
              tip: "applicant",
            },
            {
              title: "NB4",
              tip: "company incorporate page",
            },
            {
              title: "NB11",
              tip: "terminate time",
            },
          ],
        },
      ],
      triggerTypes: [
        {
          title: "Sign Up",
          value: "SIGN_UP",
        },
        {
          title: "Sign Up Success",
          value: "SIGN_UP_SUCCESS",
        },
        {
          title: "Reset Password",
          value: "RESET_PASSWORD",
        },
        {
          title: "Reset Password Success",
          value: "RESET_PASSWORD_SUCCESS",
        },
        {
          title: "Change Email",
          value: "CHANGE_EMAIL",
        },
        {
          title: "10, 30, 50 days after the request has been created and the request has not been submitted",
          value: "COMPANY_APPLYMENT_PARTLY_FILLED_OUT",
        },
        {
          title: "After submitting the requisition and creating the order",
          value: "COMPANY_APPLYMENT_INVOICE",
        },
        {
          title: "Order payment is successful or collection is confirmed",
          value: "COMPANY_APPLYMENT_ORDER_COMPLETE",
        },
        {
          title: "Business person's rejection",
          value: "COMPANY_APPLYMENT_REJECTED",
        },
        {
          title: "Gov feedback failed",
          value: "COMPANY_APPLYMENT_ACRA_REJECTED",
        },
        {
          title: "Gov feedback passed",
          value: "COMPANY_INCORPORATED",
        },
        {
          title: "The business staff initiated the refund and the first level auditor and reviewer approved it",
          value: "ORDER_REFUNDING",
        },
        {
          title: "The financial staff confirmed that the refund was successful",
          value: "ORDER_REFUNDED",
        },
        {
          title: "After Company Application is Partially Paid",
          value: "COMPANY_APPLYMENT_ORDER_PARTLY_PAID",
        },
        {
          title: "Company Customization Invoice Notify",
          value: "COMPANY_APPLYMENT_PART_INVOICE",
        },
        {
          title: "Company Customization Partially Paid",
          value: "COMPANY_APPLYMENT_PART_ORDER_PARTLY_PAID",
        },
        {
          title: "Company Customization Payment Received",
          value: "COMPANY_APPLYMENT_PART_ORDER_COMPLETE",
        },
        {
          title: "Quotation Passed",
          value: "QUOTATION_PASSED",
        },
        {
          title: "Company Customization Terminated",
          value: "APPLYMENT_TERMINATED",
        },
      ],
    };
  },
  computed: {
    noContent() {
      return this.dataList.length === 0;
    },
  },
  activated() {
    this.getDataList();
  },
  methods: {
    /* 格式化 */
    templateFormat(value) {
      const type = this.templateTypes.find(i => i.value === value);
      return type?.title;
    },
    /* 格式化 */
    // 获取数据列表
    async getDataList() {
      this.dataListLoading = true;
      const { data } = await this.$http.get("/admin/emailTemplateManage/getList");
      this.dataList = data;
      this.dataListLoading = false;
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    async deleteHandle(id) {
      await this.$confirm(`Delete this Email Template. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.post(`/admin/emailTemplateManage/${id}/delete`);
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => this.getDataList(),
        });
      } else {
        this.$message.error(msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
